import React, { useState } from 'react';

const DrawerContext = React.createContext({
  open: null,
  setOpen: () => null,
});

export function DrawerProvider({ children }) {
  const [open, setOpen] = useState(true);

  return (
    <DrawerContext.Provider value={{ open, setOpen }}>
      {children}
    </DrawerContext.Provider>
  );
}

export default DrawerContext;
